<template>
    <div>
        <b-container class="pt-5 pb-5">
            <div class="text-center">
                <img alt="Tixgo" src="../assets/logo_white.svg" class="mb-5" width="120" />
            </div>
            <b-card no-body class="login-card">
                <b-card-body>
                    <ValidationObserver ref="form1" slim>
                        <template v-if="has_success">
                            <div class="text-center mb-4">
                                <font-awesome-icon class="text-primary mb-3" icon="fa-solid fa-envelope" size="5x" />
                                <h1 class="fs-3 fs-light mb-3">Wachtwoord aangevraagd</h1>
                                <div class="m-auto text-muted">
                                    <p>U ontvangt per e-mail een link om uw wachtwoord te herstellen.</p>
                                    <p>Ga naar uw e-mailinbox en volg de instructies.</p>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <form @submit.prevent="recovery" novalidate="novalidate">
                                <div class="text-center mb-4">
                                    <h1 class="fs-light">Wachtwoord vergeten</h1>
                                    <div>
                                        Bestaande klant?
                                        <router-link to="/account/login" class="link-primary font-weight-bolder">
                                            Inloggen op je Account
                                        </router-link>
                                    </div>
                                </div>

                                <b-alert variant="danger" show v-if="has_error">
                                    Uw account is niet gevonden.
                                </b-alert>

                                <ValidationProvider rules="required|email" v-slot="{ errors }">
                                    <div class="mb-4">
                                        <label>E-mail</label>
                                        <b-form-input v-model="input.username" placeholder="mijn@account.nl" :class="errors.length > 0 ? 'is-invalid' : null" />
                                        <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                                    </div>
                                </ValidationProvider>

                                <!--right::Input group-->
                                <!--begin::Actions-->
                                <div class="text-center">
                                    <!--begin::Submit button-->
                                    <b-button variant="primary" @click="recovery()" block>
                                        Wachtwoord aanvragen
                                    </b-button>
                                    <!--right::Submit button-->
                                </div>
                                <!--right::Actions-->
                            </form>
                        </template>
                    </ValidationObserver>
                </b-card-body>
            </b-card>
        </b-container>
    </div>
</template>

<script>
    import { ValidationObserver, ValidationProvider } from 'vee-validate';

    export default ({
        components: {
            ValidationObserver,
            ValidationProvider,
        },
        metaInfo: {
            title: 'Registeren',
        },
        data() {
            return {
                has_success: false,
                has_error: false,
                input: {
                    username: "",
                }
            }
        },
        methods: {
            async recovery() {

                this.has_success = false;
                this.has_error = false;

                let check = await this.$refs['form1'].validate();

                if (!check) {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                    return;
                }

                this.$axios.post("https://api.tixgo.nl/accounts/recover", this.input)
                .then( response => {
                    if (response.data.status == 'success') {
                        this.has_success = true;
                    } else {
                        this.has_error = true;
                    }
                });
            }
        }
    });
</script>

<style scoped>
    .login-card{
        max-width:90%;
        margin:auto;
    }

    @media screen and (min-width:600px) {
        .login-card{
            max-width:500px;
        }
    }
</style>